/**
 * Locations Page Code
 *
 * Each unique page (or template) has its own page script.  These
 * scripts are loaded into the template, along with the main.js
 * script, and any vendor scripts needed for the site.  The
 * individual page scripts add a 'page' object into the main
 * Otto namespace, and the main.js file then init()'s this
 * page object to execute whatever page-specific code needs
 * to be run.
 */

/* global google */

var Otto = Otto || {};
Otto.page = (function(my, $) {
    // Create object for storing our methods for public consumption
    // (this sets up our external API for this module)
    var exports = {},
        MASS = {id:'ma', slug:'massachusetts'}, // set some 'constants' for state names
        MAINE = {id:'me', slug:'maine'},        // set same for other states...
        NEWHAMPSHIRE = {id:'nh', slug:'new-hampshire'}, // set same for other states...

        $stateBlocks = null,        // main state blocks - should be
                                    // sized specifically per window width
        stateBlockActiveClass = null,
        stateBlockInactiveClass = null,
        $stateSelectItems = null,
        stateSelectRatio = null,    // store width/height ratios of largest
                                    // state select element (ie. the svg's)
        $statePhotoBlock = null,    // block used to hold our state photos
        $statePhotos = null,        // our two individual state photo containers
        $locationBlockItems = null, // the block items in our 'location-block' container
        activeState = null,         // which (geo) state is active
        activeLoc = null,           // which location (store) is active
        sizerTimeout = null,
        $currLocContainer = null,   // store reference to the info block container
                                    // where our currently displayed location's info
                                    // originated (need to be able to put info block
                                    // back when next restaurant is selected)
        $currLocInfo = null;        // similarly, store reference to the currently
                                    // displayed block of info for the location


    function adjustSizes() {
        var winH = $(window).height(), //  - 2,  // adjust for 1px top pad used
                                            // to fix margin issue
            containerH = null,
            containerW = $stateBlocks.first().width(),
            contentH = null;

        // NOTE: If we're on desktop, we want to size the container 
        // measurement based on the number of state blocks, NOT on the
        // size of the actual container.  This is because when viewing
        // the list view for a given state block, the container is changed
        // to 50% width in our CSS, which will give a bad reading for the
        // return to the state SVG view.  Using the number of states ensures
        // that we always get an accurate measurement.
        if (window.innerWidth > 1024) {
            // Only relevant on desktop
            const headerWidth = $('#header').width();
            containerW = ($(window).width() - headerWidth) / $stateBlocks.length;
        }
        // Check for banner - subtract banner height if present
        var $banner = $('.top-banner');
        if ($banner.length) {
            winH -= $banner.height();
        }

        // first off, ensure the outer countainer is always sized propertly
        $('.locations-wrap').height(winH);

        // get height of container (half win height for sub-desktop)
        // NOTE: we only stack the blocks if A) we're in tablet vertical
        // or mobile size, and B) there is no active state currently
        // selected.
        if (my.util.isDesktop()) {
            // desktop size -- side by side columns
            containerH = winH;
        } else if (!my.util.isMobile()) {
            // tablet size
            if (activeState === null) {
                // if no state is active, stack the blocks
                containerH = winH / $stateBlocks.length;
            } else {
                // otherwise, see if there is space to stack -- if not, go full height
                var activeBlock = $('.state-block--' + activeState);
                contentH = activeBlock.find('.locations-list__title').outerHeight() +
                           activeBlock.find('.locations-list__container').outerHeight() + 110; // accommodate space at top
                if (contentH > (winH / 2)) {
                    // content doesn't fit in half-height block.  let go full height.
                    containerH = winH;
                } else {
                    // content DOES fit -- go with half-height
                    // Note that here, we use a half/half split between the selected state,
                    // and its photos, which sit side-by-side below it.
                    containerH = winH / 2;
                }
            }
        } else {
            // mobile -- stacked if no state selected, otherwise full height
            if (activeState === null) {
                containerH = winH / $stateBlocks.length;
            } else {
                containerH = winH;
            }
        }

        // keep the height of each main 'block' sized
        // correctly
        $.each($stateBlocks, function(index, el) {
            $(el).height(containerH);
        });

        // keep state select items properly sized/positioned
        $.each($stateSelectItems, function(index, el) {
            var targetH,   // target height for item in px
                targetW;   // target width for item in px

            if (containerW > containerH) {
                targetH = containerH * 0.9;
                targetW = targetH * stateSelectRatio;
            } else {
                targetW = containerW * 0.9;
                targetH = targetW / stateSelectRatio;
            }
            $(el).width(targetW);
            var topMargin = (containerH - targetH) / 2,
                leftMargin = (containerW - targetW) / 2;
            $(el).css({paddingBottom:targetH});
            $(el).css({marginTop:topMargin});
            $(el).css({marginLeft:leftMargin});
        });

        // keep the height of the state photo blocks sized correctly
        $.each($statePhotos, function(index, el) {
            if (my.util.isDesktop()) {
                // photos are stacked
                $(el).height(containerH / 2);
            } else {
                // photos are side-by-side
                $(el).height(containerH);
            }
        });

        // keep the height of the location blocks (info, map, and photo) sized correctly
        var locBlockH,
            locBlock = $('.location-block');
        if (my.util.isMobile()) {
            // only 'info' and 'map' are shown -- no photo
            // ensure there's enough height for the info -- expand the block if needed
            contentH = locBlock.find('.data-info__block').outerHeight();
            if (contentH > (winH / 2)) {
                // content doesn't fit in equal sized blocks.  let go 2/3 height.
                locBlockH = [(winH / 3) * 2, (winH / 3)];
            } else {
                // content DOES fit -- go with half-height
                locBlockH = winH / 2;
            }

            // Go with an even split (user can scroll top area if text doesn't fit)
            /*
            locBlockH = winH / 2;
            $('.location-block__item--photo').hide();
            */
        } else {
            // all 3 blocks are shown -- BUT, make sure there's enough room for all 3
            /*
            contentH = locBlock.find('.data-info__block').outerHeight();
            if (contentH > (winH / 3)) {
                // content doesn't fit in third-height block.  let go half height.
                locBlockH = winH / 2;
                $('.location-block__item--photo').hide();
            } else {
                // content DOES fit -- go with third-height
                locBlockH = winH / 3;
                $('.location-block__item--photo').show();
            }
            */
            // Go with 3 blocks (user can scroll top area if text doesn't fit)
            locBlockH = winH / 3;
            $('.location-block__item--photo').show();
        }
        $.each($locationBlockItems, function(index, el) {
            var hVal;
            if (typeof locBlockH === 'object') {
                // if value passed in is an array, grab the relevant entry
                hVal = locBlockH[index];
            } else {
                hVal = locBlockH;
            }
            $(el).height(hVal);
        });

        // As a final step, dispatch notification that the body size has
        // changed.  We need this for adjusting other size-related elements
        // (eg. visibility of the sidebar 'aux' element)
        var evt = $.Event( "bodySizeChange" );
        $('body').trigger(evt);
    }

    // when a state is clicked on, activate it
    function activateState(state) {
        $stateBlocks.removeClass(stateBlockActiveClass + ' ' + stateBlockInactiveClass);
        // set the class that identifys the active state block
        var activeIdentifyingClass = 'state-block--' + state;
        $.each($stateBlocks, function(index, el) {
            if ($(el).hasClass(activeIdentifyingClass)) {
                $(el).addClass(stateBlockActiveClass);
            } else {
                $(el).addClass(stateBlockInactiveClass);
            }
        });
        activeState = state;

        // let's also show the list of locations
        revealLocationsList(activeState);

        // and activate the state photos
        revealStatePhotos(activeState);

        // adjust item sizes, in case our blocks changed shape
        // as part of the activation process
        adjustSizes();
    }

    function deactivateStates() {
        $stateBlocks.removeClass(stateBlockActiveClass + ' ' + stateBlockInactiveClass);
        $stateBlocks.find('.locations-list').hide();
        hideStatePhotos(activeState);
        activeState = null;
        adjustSizes();
    }

    // add correct classes to reveal the state photos for the selected state
    function revealStatePhotos(state) {
        var activeIdentifyingClass = 'state-photos--' + state,
            activeIdentifyingAttr = 'data-photo-' + state;
        $statePhotoBlock.addClass('state-photos--active ' + activeIdentifyingClass);
        // load up the correct photos per the active state
        $.each($statePhotos, function(index, el) {
            var $el = $(el),
                src = 'url("' + $el.attr(activeIdentifyingAttr) + '")';
            $(el).css('backgroundImage', src);
        });
    }

    // when we leave the 'state landing' view, we remove the classes
    // responsible for showing photos in our state photos block
    function hideStatePhotos(state) {
        var activeIdentifyingClass = 'state-photos--' + state;
        $statePhotoBlock.removeClass('state-photos--active ' + activeIdentifyingClass);
    }

    // at the start of the page init, check to see if our template
    // already has an 'active' class assigned to the state photos
    // block.  if so, we need to finish setting up the photos
    // for display.
    function checkForStatePhotoLoad(state) {
        if ($('.state-photos--active').length > 0) {
            revealStatePhotos(state);
        }
    }

    // when a state is activated, we reveal its list of locations
    function revealLocationsList(state) {
        var activeIdentifyingClass = 'state-block--' + state;
        $('.' + activeIdentifyingClass).find('.locations-list').fadeIn();
    }

    // used at startup to determine if there's an already active state block
    function checkForActiveState() {
        var block = $('.state-block--active');
        if (block.length > 0) {
            if (block.hasClass('state-block--me')) {
                return MAINE.id;
            } else if (block.hasClass('state-block--ma')) {
                return MASS.id;
            } else if (block.hasClass('state-block--nh')) {
                return NEWHAMPSHIRE.id;
            }
        }
        return null;
    }

    // used at startup to determine if there's an already active location block
    function checkForActiveLoc() {
        var block = $('.location-block--active');
        if (block.length > 0) {
            var slugAttr = block.attr('data-load-slug');
            if (typeof slugAttr !== typeof undefined && slugAttr !== false) {
                return slugAttr;
            }
        }
        return null;
    }

    // Here, we display information for a particular location based on
    // the provided location entry slug
    function activateLocation(slug) {
        var stateName,
            photoPath, src,
            $map, lat, lng, title, isClosed;

        // If the current location info container is not empty, means
        // we have an active info item being displayed.  We need to
        // return it to its original location before replacing it.
        if ($currLocContainer !== null && $currLocInfo !== null) {
            $currLocInfo.appendTo($currLocContainer);
        }

        $('.location-block').addClass('location-block--active');
        activeLoc = slug;

        // grab data for this location (is contained within the page)
        stateName = getStateSlug(activeState);
        $currLocContainer = $('.' + stateName).find('.' + slug);

        // set up our location info for display
        var $itemInfoBlock = $('.location-block__item--info');
        $currLocInfo = $currLocContainer.find('.data-info');
        $itemInfoBlock.hide();
        $currLocInfo.appendTo($itemInfoBlock);
        $itemInfoBlock.fadeIn();

        // set up our map for display
        $map = $currLocContainer.find('.data-map');
        lat = $map.attr('data-lat');
        lng = $map.attr('data-lng');
        title = $map.attr('data-title');
        isClosed = $map.attr('data-is-closed') == "1";
        renderMap(lat, lng, title, isClosed);

        // set up our photo for display
        photoPath  = $currLocContainer.find('.data-photo').attr('data-path');
        $('.location-block__item--photo').css({'opacity':0.0});
        setTimeout(function() {
            $('<img/>').attr('src', photoPath).load(function() {
                $(this).remove(); // prevent memory leaks
                $('.location-block__item--photo')
                    .css({"backgroundImage": 'url("' + photoPath + '")', "opacity":1.0});

            });
        }, 250);    // give fadeout a moment to 'take' before loading next

    }

    // Called when we're backing out of a location display.
    function deactivateLocation() {
        // remove 'active' class from the location-block
        $('.location-block').removeClass('location-block--active');
        // remove 'active' class from location links
        $('.locations-list__link').removeClass('locations-list__link--active');
        activeLoc = null;
    }

    // Get the state name (slug) for the currently active state
    function getStateSlug(stateId) {
        switch (stateId) {
            case MASS.id:
                return MASS.slug;
            case MAINE.id:
                return MAINE.slug;
            case NEWHAMPSHIRE.id:
                return NEWHAMPSHIRE.slug;
        }
        return null;
    }

    // Render map based on lat/lng values
    function renderMap(lat, lng, title, isClosed) {
        var latLng = my.map.getPoint(lat, lng),
            marker = null,
            markerTxt = title;

        my.map.getMap('gMap', latLng);
        my.map.clearMarkers();

        if (isClosed) {
            markerTxt += '<br><strong>TEMPORARILY CLOSED</strong>'
        }

        marker = my.map.addMarker(latLng, title, markerTxt);

        if (!isClosed) {
            marker.addListener('click', function() {
                window.open('http://maps.google.com/?q=' + lat + ',' + lng);
            });
        }

    }

    function wireEvents() {
        // Set up window resize listener
        $(window).resize(function(evt){
            adjustSizes();
        });
        // Set up main state select links
        $('.state-block__state-select--me').click(function(evt) {
            evt.preventDefault();
            window.history.pushState(null, null, '/locations/maine/');
            activateState(MAINE.id);
        });
        $('.state-block__state-select--ma').click(function(evt) {
            evt.preventDefault();
            window.history.pushState(null, null, '/locations/massachusetts/');
            activateState(MASS.id);
        });
        $('.state-block__state-select--nh').click(function(evt) {
            evt.preventDefault();
            window.history.pushState(null, null, '/locations/new-hampshire/');
            activateState(NEWHAMPSHIRE.id);
        });
        // Set up 'back' links
        $('.back-link--to-landing').click(function(evt) {
            evt.preventDefault();
            window.history.pushState(null, null, '/locations/');
            deactivateStates();
            deactivateLocation();
        });
        $('.back-link--to-list').click(function(evt) {
            evt.preventDefault();
            var stateSlug = getStateSlug(activeState);
            window.history.pushState(null, null, '/locations/' + stateSlug);
            deactivateLocation();
            // Also want to show state photos...
            revealStatePhotos(activeState);
        });
        // Hook up location links
        $('.locations-list__link').click(function(evt) {
            var slug = $(evt.target).attr('data-slug'),
                stateSlug = getStateSlug(activeState),
                href = $(evt.target).attr('href');
            evt.preventDefault();

            // If an actual URL is provided, means we have a Yext location
            // page to go to.  Do that.
            if (href !== '#') {
                window.location.href = href;
                return;
            }

            // if this is the same location as we're already in, do nothing
            if (slug === activeLoc) return;

            // set the highlight state on the selected location link
            $('.locations-list__link').removeClass('locations-list__link--active');
            $(evt.target).addClass('locations-list__link--active');

            window.history.pushState(null, null, '/locations/' + stateSlug + '/' + slug);
            hideStatePhotos(activeState);
            activateLocation(slug);

            // set up brief delay, after which we adjust page sizes.  this
            // will allow for us to get an accurate reading of content sizes
            // in case we need to adjust for copy overflow
            if (sizerTimeout !== null) {
                clearTimeout(sizerTimeout);
            }
            sizerTimeout = setTimeout(adjustSizes, 1000);
        });
    }



    exports.init = function() {

        stateBlockActiveClass = 'state-block--active';
        stateBlockInactiveClass = 'state-block--inactive';

        // Store a reference to commonly used elements
        $stateBlocks = $('.state-block');
        $stateSelectItems = $('.state-block__state-select');
        $statePhotoBlock = $('.state-photos');
        $statePhotos = $('.state-photos__photo');
        $locationBlockItems = $('.location-block__item');

        // use the width and height from the first svg item
        // to determine a ratio to use in sizing our select
        // items (ie the svg's)
        var el = $stateSelectItems.first(),
            w = el.find('svg').attr('width'),
            h = el.find('svg').attr('height');

        stateSelectRatio = w/h;

        // let's check to see if any of the state blocks are 'active' at
        // startup.  this would be the case if we arrived at a deep
        // link to either a particular state, or location.
        activeState = checkForActiveState();

        if (activeState !== null) {
            // if not null, let's also show the list of locations
            revealLocationsList(activeState);
            // and if we're on a state landing page (ie no specific location
            // was requested), let's also set up our state photos
            checkForStatePhotoLoad(activeState);
        }

        // let's also check to see if any locations were requested at
        // startup.
        activeLoc = checkForActiveLoc();

        if (activeLoc !== null) {
            // if not null, let's show this location
            activateLocation(activeLoc);
        }

        // Init map
        // initMap();

        // Set proper heights on our elements
        adjustSizes();

        wireEvents();
    };

    return exports;

})(Otto, jQuery);